module.exports = __webpack_public_path__ + "img/example_banner.a1d51b59.png";